import TelephonesList from './TelephonesList';

import TelephoneEditeur from './TelephoneEditeur';
import TelephoneListItem from './TelephoneListItem';
export default {
  install(Vue) {
    Vue.component('telephonesList', TelephonesList);
    Vue.component('telephoneEditeur', TelephoneEditeur);
    Vue.component('telephoneListItem', TelephoneListItem);
  },
};
